// Wizard Daily Staff Access Report
import { getSections } from "./common";
import { getStorage } from "store/local";

const KIND = [
  { id: "", name: "" },
  { id: "assistance", name: "Asistencia" },
  { id: "absence", name: "Inasistencia" },
];

function layout() {
  const session = getStorage("ctxSession");
  const dom = [["chiefs", "=", session?.user_employee]];
  const ctxView = {
    model: "staff_access.daily_report",
    reportName: "staff_access_extratime.daily_report",
    fields: {
      start_date: {
        type: "date",
        required: true,
      },
      end_date: {
        type: "date",
        required: true,
      },
      sections: {
        type: "one2many",
        model: "staff.section",
        preloaded: true,
        preOptions: getSections,
        required: true,
        layout: {
          selectable: "multi",
          model: "staff.section",
          softDomain: dom,
          limit: 350,
          table_action: [],
          fields: {
            name: { type: "char" },
          },
          list: [{ name: "name" }],
        },
      },
      kind: {
        type: "selection",
        preloaded: true,
        options: KIND,
        required: true,
        default: { id: "assistance", name: "Asistencia" },
      },
      only_overtime: {
        type: "boolean",
      },
    },
    list: [],
    form: [
      { name: "start_date" },
      { name: "end_date" },
      { name: "kind" },
      { name: "only_overtime" },
      {
        name: "sections",
        type: "grid",
        elements: [{ name: "sections" }],
        colSpan: "col-span-2",
      },
    ],
  };
  return ctxView;
}

export { layout };
